module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-publications-recognition"
  }, [_c('h1', {
    staticClass: "custom-publications-recognition__title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _c('div', {
    staticClass: "custom-publications-recognition__container"
  }, [_c('div', {
    staticClass: "custom-publications-recognition__col-body"
  }, [_c('div', {
    staticClass: "custom-publications-recognition__body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })]), _c('div', {
    staticClass: "custom-publications-recognition__tiles"
  }, _vm._l((_vm.content.slider), function(tile, i) {
    return _c('div', {
      key: "tile-" + i,
      staticClass: "custom-publications-recognition__tile"
    }, [(tile.href) ? _c('a', {
      attrs: {
        "href": tile.href,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "custom-publications-recognition__tile-img",
      class: {
        'custom-publications-recognition__tile-img--active': i === _vm.activeImage
      },
      attrs: {
        "src": tile.image
      }
    })]) : _vm._e(), (!tile.href) ? _c('img', {
      staticClass: "custom-publications-recognition__tile-img",
      class: {
        'custom-publications-recognition__tile-img--active': i === _vm.activeImage
      },
      attrs: {
        "src": tile.image
      },
      on: {
        "click": function($event) {
          _vm.showModal(i)
        }
      }
    }) : _vm._e()])
  }))]), _c('div', {
    staticClass: "custom-publications-recognition__container"
  }, [_c('div', {
    staticClass: "custom-publications-recognition__col-bottom"
  }, [_c('div', {
    staticClass: "custom-publications-recognition__body custom-publications-recognition__body--bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body_bottom)
    }
  })])]), _vm._l((_vm.content.slider), function(modal, i) {
    return _c('div', {
      key: "modal - " + i,
      staticClass: "custom-publications-recognition__modal",
      class: {
        'custom-publications-recognition__modal--showing': _vm.showingModal === i
      }
    }, [_c('div', {
      staticClass: "custom-publications-recognition__modal-overlay",
      on: {
        "click": _vm.closeModal
      }
    }), _c('div', {
      staticClass: "custom-publications-recognition__modal-container"
    }, [_c('div', {
      staticClass: "custom-publications-recognition__modal-close",
      on: {
        "click": _vm.closeModal
      }
    }, [_vm._v("Close")]), _c('h1', {
      staticClass: "custom-publications-recognition__modal-title",
      domProps: {
        "innerHTML": _vm._s(modal.title)
      }
    }), _c('div', {
      staticClass: "custom-publications-recognition__modal-body",
      domProps: {
        "innerHTML": _vm._s(modal.body)
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bcbc634","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-publications-recognition/custom-publications-recognition.pug
// module id = 664
// module chunks = 1